import { useEffect, useState } from "react";
import { fetchPricingPlan, addOrEditPricing } from "../../utils/wellspoken.api";
import toast from "react-hot-toast";

/* ---------------- Tailwind tokens ---------------- */
const section = "bg-surface ";
const container = "max-w-7xl mx-auto px-4";
const grid = "mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8";

const card =
  "rounded-2xl bg-white border border-border shadow-sm p-6 transition-all duration-300 ease-out-soft hover:-translate-y-1 hover:shadow-md animate-scale-soft";

const input =
  "w-full rounded-lg border border-border px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary";

const btnPrimary =
"px-6 py-2 rounded-full text-sm font-medium bg-gradient-to-r from-blue-600 to-indigo-600 text-white hover:from-blue-500 hover:to-indigo-500 focus-visible:outline-none  focus-visible:ring-2 focus-visible:ring-blue-500/40 disabled:opacity-60 transition";

const btnOutline =
  "px-4 py-2 rounded-full text-sm font-medium text-white bg-primary-light hover:opacity-90 focus-visible:ring-2 focus-visible:ring-primary";

/* ---------------- Component ---------------- */
const ViewPricing = () => {
  const [pricingList, setPricingList] = useState([]);
  const [editingPlan, setEditingPlan] = useState(null);
  const [formData, setFormData] = useState({
    PlanId: "",
    PlanName: "",
    PlanFeature: "",
    Pricetype: "",
    Price: "",
    //PriceStatus: "",
    Isdelete: false,
  });

  /* ---------- Load all pricing ---------- */
  const loadPricing = async () => {
    const data = await fetchPricingPlan();
    const normalized = Array.isArray(data) ? data : [data];
    setPricingList(normalized.filter(p => p.planStatus === "Active"));
  };

  useEffect(() => {
    loadPricing();
  }, []);

  /* ---------- Edit ---------- */
  const handleEdit = (plan) => {
    setEditingPlan(plan);
    setFormData({
      PlanId: plan.planId,
      PlanName: plan.planName,
      PlanFeature: plan.planFeature,
      Pricetype: plan.pricetype,
      Price: plan.price,
     // planStatus: plan.planStatus,
      Isdelete: false,
    });
  };
  
  const handleDelete = async () => {
  try {
    await addOrEditPricing({
      ...formData,
      Isdelete: true, // 🔥 this triggers delete
    });

    toast.success("Pricing Plan deleted successfully 🗑️");
    setEditingPlan(null);
    loadPricing(); // refresh list
  } catch (err) {
    toast.error("Failed to delete pricing plan");
  }
};


  /* ---------- Save ---------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    await addOrEditPricing(formData);
     toast.success("Pricing Plan updated successfully 🎉");
    setEditingPlan(null);
    loadPricing(); // refresh list
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <section className={section}>
      <div className={container}>
        <h1 className="text-3xl md:text-4xl font-bold text-textPrimary text-center">
          Our Pricing Plans
        </h1>

        {/* ================= PRICING LIST ================= */}
        <div className={grid}>
          {pricingList.map(plan => (
            <div key={plan.planId} className={card}>
              <h2 className="text-xl font-semibold text-textPrimary">
                {plan.planName}
              </h2>

              {/* <p className="mt-1 text-sm text-textSecondary">
                {plan.pricetype}
              </p>

              <p className="mt-4 text-3xl font-bold text-textPrimary">
                ₹{plan.price}
              </p> */}
              <p className="mt-4 text-3xl font-bold text-textPrimary">
                ₹{plan.price}
                <span className="ml-2 text-sm font-medium text-textSecondary">
                  /{plan.pricetype}
                </span>
              </p>
              <ul className="mt-4 space-y-2 text-sm text-textSecondary">
                {Array.isArray(plan.planFeature)
                  ? plan.planFeature.map((f, i) => <li key={i}>• {f}</li>)
                  : plan.planFeature
                    ?.split("\n")
                    .map((f, i) => <li key={i}>• {f.trim()}</li>)}
              </ul>
              <div className="mt-6 flex gap-3">
                <button
                  onClick={() => handleEdit(plan)}
                  className={btnPrimary}
                >
                  Edit
                </button>

                <button className={btnOutline}
                  onClick={() =>handleDelete(plan)}
                  >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ================= EDIT MODAL ================= */}
      {editingPlan && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
          role="dialog"
          aria-modal="true"
        >
          <div className="w-full max-w-lg rounded-2xl bg-white border border-border p-6 animate-fade-up">
            <h2 className="text-xl font-semibold text-textPrimary mb-4">
              Edit Pricing Plan
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4">
              <input
                name="PlanName"
                value={formData.PlanName}
                onChange={handleChange}
                className={input}
                placeholder="Plan Name"
                required
              />

              <input
                name="Pricetype"
                value={formData.Pricetype}
                onChange={handleChange}
                className={input}
                placeholder="Price Type"
                required
              />

              <input
                name="Price"
                value={formData.Price}
                onChange={handleChange}
                className={input}
                placeholder="Price"
                required
              />

              <textarea
                name="PlanFeature"
                value={formData.PlanFeature}
                onChange={handleChange}
                rows={4}
                className={input}
                placeholder="Features (one per line)"
              />

              {/* Plan Status Dropdown */}
              {/* <select
                name="PlanStatus"
                value={formData.PlanStatus}
                onChange={handleChange}
                className="w-full rounded-lg border border-border px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select> */}

              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setEditingPlan(null)}
                  className={btnOutline}
                >
                  Cancel
                </button>

                <button type="submit" className={btnPrimary}>
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
};

export default ViewPricing;
